import { CURRENCY_SIGNS, DEFAULT_LOCALE } from '@/types'
import type { Invoice } from '@/types'

interface ItemsBlockProps {
	invoice: Invoice
}

function formatMoney(value: number, currency: string): string {
	const sign = CURRENCY_SIGNS[currency] ?? currency
	const formatted = value.toLocaleString(DEFAULT_LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
	return `${formatted} ${sign}`
}

/**
 * Items table — 6 columns matching the printed invoice template:
 * №, name, qty, unit, price, amount.
 */
export function ItemsBlock({ invoice }: ItemsBlockProps) {
	const items = invoice.items ?? []
	return (
		<table className="w-full border-collapse text-xs">
			<thead>
				<tr className="text-(--color-muted-foreground)">
					<th className="w-10 border border-(--color-foreground) px-2 py-1 text-center font-[500]">№</th>
					<th className="border border-(--color-foreground) px-2 py-1 text-left font-[500]">Товары (работы, услуги)</th>
					<th className="w-16 border border-(--color-foreground) px-2 py-1 text-center font-[500]">Кол-во</th>
					<th className="w-12 border border-(--color-foreground) px-2 py-1 text-center font-[500]">Ед.</th>
					<th className="w-28 border border-(--color-foreground) px-2 py-1 text-right font-[500]">Цена</th>
					<th className="w-28 border border-(--color-foreground) px-2 py-1 text-right font-[500]">Сумма</th>
				</tr>
			</thead>
			<tbody>
				{items.length === 0 ? (
					<tr>
						<td className="border border-(--color-foreground) px-2 py-2 text-center text-(--color-muted-foreground)" colSpan={6}>—</td>
					</tr>
				) : (
					items.map((it, idx) => {
						const qty    = Number(it.qty ?? '1')
						const amount = Number(it.amount)
						const price  = qty > 0 ? amount / qty : amount
						return (
							<tr key={it.id ?? idx}>
								<td className="border border-(--color-foreground) px-2 py-1 text-center">{idx + 1}</td>
								<td className="border border-(--color-foreground) px-2 py-1">{it.description}</td>
								<td className="border border-(--color-foreground) px-2 py-1 text-center">{qty}</td>
								<td className="border border-(--color-foreground) px-2 py-1 text-center">{it.unit ?? '—'}</td>
								<td className="border border-(--color-foreground) px-2 py-1 text-right">{formatMoney(price, invoice.currency)}</td>
								<td className="border border-(--color-foreground) px-2 py-1 text-right">{formatMoney(amount, invoice.currency)}</td>
							</tr>
						)
					})
				)}
			</tbody>
		</table>
	)
}
